import React, { useEffect, useState } from 'react';
import { useFriend } from '../../hooks/use-friend/useFriend';
import { IFriend } from '../../types/friend';
import classNames from 'classnames';
import _size from 'lodash/size';
import { IChat } from '../../types/chat';
import { FcSettings } from 'react-icons/fc';
import { SearchIcon } from 'lucide-react';

interface ListFriendChatProps {
  listNewMessage: IChat[];
  currentChat: IFriend | null;
  onSelect: (friend: IFriend) => void;
}

const ListFriendChat = ({
  listNewMessage,
  currentChat,
  onSelect,
}: ListFriendChatProps) => {
  const { data } = useFriend({ pageSize: 100 });
  const [filteredFriends, setFilteredFriends] = useState(data);
  const [searchQuery, setSearchQuery] = useState('');
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  useEffect(() => {
    setFilteredFriends(data);
  }, [data]);
  useEffect(() => {
    const filtered = data.filter((friend) =>
      friend.fullName.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredFriends(filtered);
  }, [searchQuery]);

  return (
    <div className="md:w-[410px] relative border-r dark:border-slate-700">
      <div className="top-0 left-0 max-md:fixed max-md:w-5/6 max-md:h-screen bg-white z-50 max-md:shadow max-md:-translate-x-full dark:bg-dark2">
        <div className="p-3 border-b dark:border-slate-700">
          {/* <div className="flex mt-2 items-center justify-between">
            <h2 className="text-2xl font-bold text-black ml-1 dark:text-white"> Chats </h2>

            <div className="flex items-center gap-2.5">
              <button>
                <FcSettings size={24} />
              </button>
            </div>
          </div> */}
          <div className="relative">
            <div className="absolute left-3 bottom-1/2 translate-y-1/2 flex">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.625 15.8026C12.56 15.8026 15.75 12.6127 15.75 8.67764C15.75 4.74261 12.56 1.55264 8.625 1.55264C4.68997 1.55264 1.5 4.74261 1.5 8.67764C1.5 12.6127 4.68997 15.8026 8.625 15.8026Z"
                  stroke="black"
                  strokeOpacity="0.88"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16.5 16.5526L15 15.0526"
                  stroke="black"
                  strokeOpacity="0.88"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <input
              value={searchQuery}
              onChange={handleSearchChange}
              type="text"
              placeholder="Tìm kiếm"
              className="w-full !pl-[42px] h-[42px] !py-2 text-[#737373] text-sm bg-[#F0F2F5] outline-none !rounded-lg"
            />
          </div>
        </div>
        <div className="flex flex-col overflow-y-auto md:h-[calc(100vh-204px)] h-[calc(100vh-130px)]">
          {filteredFriends?.map((friend) => (
            <div
              key={friend.userId}
              className={classNames(
                `relative cursor-pointer flex items-center gap-3 px-4 py-3 duration-200 hover:bg-secondery`,
                {
                  'bg-[#F7F7F7] dark:bg-zinc-900':
                    currentChat?.userId === friend.userId,
                  '':
                    _size(listNewMessage) &&
                    listNewMessage.some(
                      (message) => message.senderUserId === friend?.userId
                    ),
                }
              )}
              onClick={() => onSelect(friend)}
            >
              <div className="relative w-12 h-12 shrink-0">
                <img
                  src={
                    friend.avatar ||
                    '/default-avatar.svg'
                  }
                  alt="avatar"
                  className="object-cover w-full h-full rounded-full"
                />
                <div
                  className={`w-4 h-4 absolute bottom-0 right-0  ${
                    friend.isOnline ? 'bg-green-500 ' : 'bg-gray-200 '
                  }rounded-full border border-white dark:border-slate-800`}
                />
              </div>
              <div className="flex-1">
                <h4 className="text-base text-[#121212] dark:text-slate-50">
                  {friend.fullName}
                </h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ListFriendChat;
